import { useContext } from 'react';
import {
  IObjektVy,
  BusinessCollectionCompType,
} from '../../../../../Types/ObjektVy';
import {
  valutaVariables,
  valuta,
  valuta_node_TEDSYSValuta as valuta_node,
  valuta_node_TEDSYSValuta__Associations as Associations,
} from './_QueryTypes/valuta';
import UpdateMutation from './ValutaUpdateMutation.gql';
import AddMutation from './ValutaAddMutation.gql';
import {
  ValutaUpdateMutation as IUpdateData,
  ValutaUpdateMutationVariables as IUpdateVariables,
} from './_QueryTypes/ValutaUpdateMutation';
import {
  ValutaAddMutation as IAddData,
  ValutaAddMutationVariables as IAddVariables,
} from './_QueryTypes/ValutaAddMutation';
import ObjektVySida from '../../../_Common/Components/BusinessCollectionComponents/ObjektVySida/ObjektVySida';
import { ObjektVyKort } from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyKort/ObjektVyKort';
import ObjektVy from '../../../_Common/Components/BusinessCollectionComponents/ObjektVy/ObjektVy';
import clientAvenyModel from '../../../../../Model/clientAvenyModel';
import { IClientBusinessModel } from '../../../../../Types/ClientModelTypes';
import IntegratedAssociationList from '../../../_Common/Components/BusinessCollectionComponents/IntegratedAssociationList/IntegratedAssociationList';
import BusinessDataForm from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import Attribut from '../../../_Common/Components/BusinessCollectionComponents/Attribut/Attribut';
import { ActiveDatabaseContext } from '../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import ValutaType from './ValutaType.gql';
import { collectionCompToObjektVy } from '../../../_Common/Components/BusinessCollectionComponents/BusinessCollectionUtils';
import {
  ApolloError,
  useMutation,
  gql as graphql,
  FetchResult,
} from '@apollo/client';
import ObjektVyKolumner, {
  ObjektVyKolumn,
} from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyKolumner/ObjektVyKolumner';
import { VisningsTypContext } from '../../../_Common/Components/BusinessCollectionComponents/VisningsTypContext/VisningsTypContext';
import { useSelectedDetailQuery } from '../../../../../Components/QueryComponents/SelectedDetailQuery/useSelectedDetailQuery';

const valutamodel: IClientBusinessModel =
  clientAvenyModel.SYS.BusinessModels.SYSValuta;

const query = graphql`
  query valuta($id: ID!) {
    node(id: $id) {
      id
      __typename
      ...ValutaType
    }
  }
  ${ValutaType}
`;

const ValutaForm = (props: {
  isNew?: boolean;
  unselect?: () => void;
  nodeData: valuta_node | null | undefined;
  nodeLoading: boolean;
  updateMutation: (values: any) => Promise<void | FetchResult<IUpdateData>>;
  addMutation: (values: any) => Promise<void | FetchResult<IAddData>>;
  mutationLoading: boolean;
  mutationError?: ApolloError;
  addNewObject?: boolean;
  fullScreen?: boolean;
  onCancel?: () => void;
  onValuesCommited?: () => void;
}) => {
  return (
    <BusinessDataForm<valuta_node>
      isNew={props.isNew}
      data={props.nodeData}
      model={valutamodel}
      updateMutation={props.updateMutation}
      addMutation={props.addMutation}
      addNewObject={props.addNewObject}
      fullScreen={props.fullScreen}
      onCancel={props.onCancel}
      onValuesCommited={props.onValuesCommited}
      mutationError={props.mutationError}
      mutationLoading={props.mutationLoading}
      newFormContext
    >
      <ObjektVy nodeLoading={props.nodeLoading} editImplemented>
        <ObjektVySida
          sidNr={1}
          caption="Valuta"
          collectionName={valutamodel.CollectionName}
        >
          <ObjektVyKolumner>
            <ObjektVyKolumn fullPage={props.fullScreen}>
              <ObjektVyKort>
                <Attribut<valuta_node> name="VALUTAKOD" />
                <Attribut<valuta_node> name="BENAMNING" />
                <Attribut<valuta_node> name="FASTKURS" />
                <Attribut<valuta_node> name="KURSFAKTOR" />
              </ObjektVyKort>
              <ObjektVyKort caption="Kurser">
                <IntegratedAssociationList<Associations>
                  associationName="Kurs"
                  label={{ name: 'IDString', label: 'Kurs' }}
                  labelAttributeNames={[]}
                  contentAttributeNames={[
                    { name: 'TOM_DATUM' },
                    { name: 'SALJKURS' },
                  ]}
                />
              </ObjektVyKort>
            </ObjektVyKolumn>
          </ObjektVyKolumner>
        </ObjektVySida>
      </ObjektVy>
    </BusinessDataForm>
  );
};

const Standard: BusinessCollectionCompType = props => {
  const visningsTypContext = useContext(VisningsTypContext);
  const { nodeData, loading } = useSelectedDetailQuery<
    valuta,
    valuta_node,
    valutaVariables
  >(query, props.id);
  const { activeDatabase } = useContext(ActiveDatabaseContext);
  const [updateMutation, updateResult] = useMutation<
    IUpdateData,
    IUpdateVariables
  >(UpdateMutation);
  const [addMutation, addResult] = useMutation<IAddData, IAddVariables>(
    AddMutation
  );
  const mutationFunction = (values: any) =>
    updateMutation({
      variables: {
        db: activeDatabase || '',
        values: {
          id: props.id,
          _version: nodeData ? nodeData._version : 1,
          ...values,
        },
      },
    });

  const addFunction = (values: any) =>
    addMutation({
      variables: {
        db: activeDatabase || '',
        values: {
          ...values,
        },
      },
    });

  return (
    <ValutaForm
      isNew={props.isNew}
      unselect={props.unselect}
      nodeData={nodeData}
      nodeLoading={loading}
      updateMutation={mutationFunction}
      addMutation={addFunction}
      fullScreen={visningsTypContext.showDetailsRight ? false : true}
      mutationLoading={updateResult.loading || addResult.loading}
      mutationError={updateResult.error || addResult.error}
    />
  );
};

const standard = collectionCompToObjektVy(Standard);
export const ValutaVyer: IObjektVy[] = [standard];
